import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import ResourcesSet from './ResourcesSet';
import ResourceSelector from './ResourceSelector';

const styles = theme => ({
  title: theme.typography.h4,
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    marginTop: 46,
  },
  container: {
    // [theme.breakpoints.up('1140')]: {
    //   width: 1172,
    //   padding: '24px 14px',
    // },
    // width: '100%',
    // padding: '24px 5%',
    // [theme.breakpoints.down('xs')]: {
    //   padding: '24px 0',
    // },
  },
  contentWrapper: {
    minHeight: 400,
  },
});

function ResourcesList(props) {
  const { classes, title } = props;
  const [activeTab, setActiveTab] = useState('Assessments');

  return (
    <div className={classes.root} id="home-page-resources">
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <Typography
            variant="h1"
            className={classes.title}
            color="textPrimary"
            align="center"
          >
            {title}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ResourceSelector activeTab={activeTab} clickHandler={setActiveTab} />
        </Grid>
        <Grid item xs={12} className={classes.contentWrapper}>
          <ResourcesSet type={activeTab} />
        </Grid>
      </Grid>
    </div>
  );
}

ResourcesList.propTypes = {
  classes: PropTypes.object,
  title: PropTypes.string,
};

ResourcesList.defaultProps = {
  title: 'Popular Resources',
};

export default withStyles(styles)(ResourcesList);
